import { render, staticRenderFns } from "./StreamsWiki.vue?vue&type=template&id=48499d78&scoped=true&"
import script from "./StreamsWiki.vue?vue&type=script&lang=ts&"
export * from "./StreamsWiki.vue?vue&type=script&lang=ts&"
import style0 from "./StreamsWiki.vue?vue&type=style&index=0&id=48499d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48499d78",
  null
  
)

export default component.exports